export default /* glsl */`
#ifdef GL_OES_standard_derivatives
#extension GL_OES_standard_derivatives : enable
#endif
    uniform sampler2D uMap;
    uniform vec3 uColor;
    uniform sampler2D uTexture;
    varying vec2 vUv;
    uniform vec3 fogColor;
    uniform float fogNear;
    uniform float fogFar;


    float median(float r, float g, float b) {
      return max(min(r, g), min(max(r, g), b));
    }

  void main(){
    vec3 color = vec3(1.);
    color = uColor;
    vec4 sample = texture2D(uMap, vUv);
    float sigDist = median(sample.r, sample.g, sample.b) - 0.5;
     float alpha = clamp(sigDist/fwidth(sigDist) + 0.5, 0.0, 1.0);

      gl_FragColor = vec4(color, alpha);

      #ifdef USE_FOG
          #ifdef USE_LOGDEPTHBUF_EXT
              float depth = gl_FragDepthEXT / gl_FragCoord.w;
          #else
              float depth = gl_FragCoord.z / gl_FragCoord.w;
          #endif
          float fogFactor = smoothstep( fogNear, fogFar, depth );
          gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
      #endif
    if (gl_FragColor.a < 0.0001) discard;
  }
`;
